// extracted by mini-css-extract-plugin
module.exports = {"Accordion__content":"Accordion_Accordion__content__H1T3h","fadeInKeyframe":"Accordion_fadeInKeyframe__6qYgZ"};